import { render } from "./ElectronicSignature.vue?vue&type=template&id=32a58bd4&scoped=true"
import script from "./ElectronicSignature.vue?vue&type=script&lang=js"
export * from "./ElectronicSignature.vue?vue&type=script&lang=js"

import "./ElectronicSignature.vue?vue&type=style&index=0&id=32a58bd4&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a58bd4"]])

export default __exports__